import keyMirror from "keymirror";

// ----------------------------------------------------------------------
// Description: Config types and constants
// ----------------------------------------------------------------------
export interface ServerConfiguration {
    REACT_APP_PORT: string;
    REACT_APP_WEB_PORT: string;
    REACT_APP_CRYPTO_SERVER: string;
    REACT_APP_CRYPTO_WEBSOCKET_SERVER: string;
    REACT_APP_BACKEND_SERVER: string;
    REACT_APP_BACKEND_WEBSOCKET_SERVER: string;
    REACT_APP_FILESYNC_SERVER: string;
    REACT_APP_FILESYNC_WEBSOCKET_SERVER: string;
    REACT_APP_KEYSTORAGE_SERVER: string;
    REACT_APP_RECAPTCHA_KEY: string;
}

export const EnvConfigKeys = keyMirror({
    REACT_APP_PORT: null,
    REACT_APP_WEB_PORT: null,
    REACT_APP_CRYPTO_SERVER: null,
    REACT_APP_CRYPTO_WEBSOCKET_SERVER: null,
    REACT_APP_BACKEND_SERVER: null,
    REACT_APP_BACKEND_WEBSOCKET_SERVER: null,
    REACT_APP_FILESYNC_SERVER: null,
    REACT_APP_FILESYNC_WEBSOCKET_SERVER: null,
    REACT_APP_KEYSTORAGE_SERVER: null,
    REACT_APP_RECAPTCHA_KEY: null,
});

export const ConfigKeys = keyMirror({
    local_app_server: null,
    local_web_server: null,
    crypto_server: null,
    crypto_websocket_server: null,
    backend_server: null,
    backend_websocket_server: null,
    filesync_server: null,
    filesync_websocket_server: null,
    keystorage_server: null,
    recaptcha_key: null
});

// Description: Store the backup values in variable from process.env
export const ConfigFallback: { [key in ConfigKeysType]: string | undefined } = {
    local_app_server: process.env.REACT_APP_PORT,
    local_web_server: process.env.REACT_APP_WEB_PORT,
    crypto_server: process.env.REACT_APP_CRYPTO_SERVER,
    crypto_websocket_server: process.env.REACT_APP_CRYPTO_WEBSOCKET_SERVER,
    backend_server: process.env.REACT_APP_BACKEND_SERVER,
    backend_websocket_server: process.env.REACT_APP_BACKEND_WEBSOCKET_SERVER,
    filesync_server: process.env.REACT_APP_FILESYNC_SERVER,
    filesync_websocket_server: process.env.REACT_APP_FILESYNC_WEBSOCKET_SERVER,
    keystorage_server: process.env.REACT_APP_KEYSTORAGE_SERVER,
    recaptcha_key: process.env.REACT_APP_RECAPTCHA_KEY,
};

// Description: there are 2 sets of variables, CRA types and the ones saved in the store
export type EnvConfigKeysType = keyof typeof EnvConfigKeys;
export type ConfigKeysType = keyof typeof ConfigKeys;